import { ChangeEvent } from 'react';
import { Button, Dialog, Textarea, TextField } from '@equinor/eds-core-react';
import styled from 'styled-components';

type ScenarioDetailsDialogField = 'name' | 'description';

type ScenarioDetailsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  value: string;
  onChange: (value: string) => void;
  isSaving: boolean;
  field: ScenarioDetailsDialogField;
};

const WideDialog = styled(Dialog)`
  width: 600px;
  max-width: 90vw;
`;

export const ScenarioDetailsDialog = ({
  isOpen,
  onClose,
  onSave,
  value,
  onChange,
  isSaving,
  field,
}: ScenarioDetailsDialogProps) => {
  const isNameField = field === 'name';
  const title = isNameField ? 'Change name' : 'Change description';
  const label = isNameField ? 'Name' : 'Description';
  const saveDisabled = isNameField ? !value.trim() || isSaving : isSaving;

  const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleTextareaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const DialogComponent = isNameField ? Dialog : WideDialog;

  return (
    <DialogComponent open={isOpen} onClose={onClose}>
      <Dialog.Header>{title}</Dialog.Header>
      <Dialog.CustomContent>
        {isNameField ? (
          <TextField
            id="scenario-name-input"
            label={label}
            value={value}
            onChange={handleTextFieldChange}
          />
        ) : (
          <Textarea
            id="scenario-description-input"
            label={label}
            value={value}
            onChange={handleTextareaChange}
            rows={8}
          />
        )}
      </Dialog.CustomContent>
      <Dialog.Actions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={saveDisabled} onClick={onSave}>
          Save
        </Button>
      </Dialog.Actions>
    </DialogComponent>
  );
};
